export default {"src":"/_next/static/media/icon-checkmark-black.83a93907.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};